import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Card, Col, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { handleLogout } from '../../utils/menuUtils';
import ParticlesAuth from '../crm-pages/AuthenticationInner/ParticlesAuth';
import avatar from '../../assets/images/users/avatar-1.jpg'

const Settings = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Logout handler
    const logout = () => handleLogout(dispatch, navigate);
    const savedLayoutMode = localStorage.getItem('layoutMode')

    const storedUser = localStorage.getItem('user');
    let userDetails = null;
    let account = null;
  
  
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        userDetails = parsedUser?.user || null;
        account  = parsedUser?.account
      } catch (error) {
        console.error('Error parsing user from localStorage:', error);
      }
    }
  

    // Menu items configuration
    const menuItems = [
        { label: 'Dashboard', icon: 'ri-dashboard-2-line', color: '#20c997', link: '/trade?tab=2' },
        { label: 'Open Position', icon: 'ri-briefcase-line', color: '#ff5733', link: '/trade?tab=3' },
        { label: 'History', icon: 'ri-history-line', color: '#6c757d', link: '/trade?tab=5' },
        // { label: 'Partner', icon: 'ri-group-line', color: '#6f42c1', link: '#' },
        // { label: 'User Dashboard', icon: 'ri-dashboard-2-line', color: '#007bff', link: '/user-dashboard' },
        // { label: 'Pam Manager', icon: 'ri-funds-box-line', color: '#ffc107', link: '/pam-manager' },
        // { label: 'Copy Trading', icon: 'ri-repeat-line', color: '#17a2b8', link: '/copy-trading' },
        // { label: 'MY IBM Area', icon: 'ri-lightbulb-line', color: '#fd7e14', link: '/ibm-area' },
        // { label: 'Trading Accounts', icon: 'ri-profile-line', color: '#007bff', link: '/trading-accounts' },
        // { label: 'Trade', icon: 'ri-bar-chart-line', color: '#28a745', link: '/trade' },
        // { label: 'Internal Transfer', icon: 'ri-exchange-dollar-line', color: '#6c757d', link: '/internal-transfer' },
        // { label: 'Demo Accounts', icon: 'ri-test-tube-line', color: '#6f42c1', link: '/demo-acounts' },
        // { label: 'My Referrals', icon: 'ri-share-forward-line', color: '#17a2b8', link: '/my-referrals' },
        // { label: 'Deposit', icon: 'ri-wallet-line', color: '#28a745', link: '/deposit' },
        // { label: 'Withdraw', icon: 'ri-bank-card-line', color: '#ffc107', link: '/withdraw-funds' },
        // { label: 'Transactions', icon: 'ri-exchange-dollar-line', color: '#17a2b8', link: '/transactions' },
        // { label: 'Support Tickets', icon: 'ri-customer-service-line', color: '#6610f2', link: '/support-tickets' },
        // { label: '2FA', icon: 'ri-fingerprint-line', color: '#343a40', link: '/two-factor-authentication' },
        // { label: 'Profile', icon: 'ri-user-line', color: '#6c757d', link: '/profile' },
        // { label: 'Change Password', icon: 'ri-lock-unlock-line', color: '#28a745', link: '/auth-pass-change' },
        { label: 'Logout', icon: 'ri-logout-box-line', color: '#d9534f', link: '/login', onClick: logout },
    ];


    return (
        <Row className="p-0">
            <Col xs={12} className="p-0 ">
                <Card className='p-3 border position-relative user-infor-setting-card bg-transparent'>

            
                        <div className="navbar-user-box-mbl d-flex justify-content-center align-items-center flex-column" style={{ position: 'relative', zIndex: 999 }}>
                            <div className="user-image border" style={{ width: "13%", borderRadius: '50%' }}>
                                <img style={{ borderRadius: '50%' }} src={userDetails?.image??""} alt="user" />
                            </div>
                            <div className="user text-center mt-2" style={{ width: "55%" }}>
                                <h3 className='mb-0'>{userDetails?.name || 'No User'}</h3>
                                <p className="mb-0 fw-bold text-secondary">{account || 'No Account'}</p>
                            </div>
                        </div>
               

                </Card>
                <ListGroup style={{ position: 'relative', zIndex: 999, }}>
                    {menuItems.map((item, index) => (
                        <ListGroupItem key={index} className="d-flex justify-content-between align-content-center fs-6 bg-transparent">
                            <Link
                                to={item.link}
                                onClick={item.onClick || null}
                                className="d-flex w-100 justify-content-between align-items-center"
                                style={{
                                    color: savedLayoutMode === 'light' ? '#343a40' : '#ffffff',
                                }}
                                role="menuitem"
                                aria-label={item.label}
                            >
                                <p className="m-0 d-flex align-items-center">
                                    <i className={`${item.icon} me-2`} style={{ color: item.color }}></i>
                                    <span style={{ fontWeight: 500 }}>{item.label}</span>
                                </p>
                                <i className="ri-arrow-right-s-line"></i>
                            </Link>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            </Col>
        </Row>
    );
};

export default Settings;
